let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let TabSet = require("../../widgets/TabSet");
let esUtils = require("ES/utils/esUtils");
let AuthedUserSession = require("../../../utils/AuthedUserSession");

//NOTE
//NOTE these keys on this are used in urls so don't casually RENAME them
//NOTE
let tabs = {};
tabs.marketplace = {
  name: "Job",
  render: require("./tabs/marketplace"),
};
tabs.details = {
  name: "Details",
  render: require("./tabs/details"),
};
tabs.contacts = {
  name: "Contacts",
  render: require("./tabs/contacts"),
};
tabs.services = {
  name: "Services",
  render: require("./tabs/services"),
};
if (AuthedUserSession.is_st_family) {
  tabs.evals = {
    name: "Feedback",
    render: require("./tabs/evals"),
  };
}
tabs.action_list = {
  name: "Action List",
  render: require("./tabs/action_list"),
};
tabs.custom = {
  name: "Custom",
  render: require("./tabs/custom"),
};
tabs.library = {
  name: "Library",
  render: require("./tabs/library"),
};
tabs.misc = {
  name: "Misc",
  render: require("./tabs/misc"),
};

if (!AuthedUserSession.is_st_family) {
  tabs.travel = {
    name: "Travel",
    render: require("./tabs/travel"),
  };
}

if (AuthedUserSession.is_st_family) {
  tabs.coaching = {
    name: "Coaching",
    render: require("./tabs/coaching"),
  };
}

/**
 * Based on the build and the user access level for the event, choose which tabs to display.
 * @param event
 * @returns {*}
 */
let determineTabNamesToDisplay = function (event) {
  //console.log("determineTabNamesToDisplay", AuthedUserSession.doIHaveAccess.full.any(event.sids), AuthedUserSession.is_cs, AuthedUserSession.is_privatelabel, AuthedUserSession.privatelabel_code, event.sids);
  if (AuthedUserSession.doIHaveAccess.travel.all(event.sids)) {
    return ["details", "travel"];
  }

  let tab_names = _.keys(tabs);

  if (!event.is_mp_event) {
    tab_names = _.without(tab_names, "marketplace");
  }

  if (
    !AuthedUserSession.doIHaveAccess.full.any(event.sids) &&
    !AuthedUserSession.doIHaveAccess.read.any(event.sids) &&
    !AuthedUserSession.doIHaveAccess.admin.any(event.sids)
  ) {
    //console.log("determineTabNamesToDisplay", "restricting [services, library]", event.sids, AuthedUserSession.doIHaveAccess.full.any(event.sids), AuthedUserSession.doIHaveAccess.read.any(event.sids), AuthedUserSession.doIHaveAccess.admin.any(event.sids));
    tab_names = _.without(tab_names, "services", "library", "evals");
  }

  if (
    AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids)
    // && !AuthedUserSession.is_cs
  ) {
    //console.log("determineTabNamesToDisplay", "restricting [action_list, custom]", event.sids, AuthedUserSession.doIHaveAccess.full.any(event.sids), AuthedUserSession.doIHaveAccess.read.any(event.sids), AuthedUserSession.doIHaveAccess.admin.any(event.sids));
    tab_names = _.without(tab_names, "action_list");
  }

  if (
    AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids) &&
    AuthedUserSession.is_cs
  ) {
    tab_names = _.without(tab_names, "misc");
  }

  if (!esUtils.getIn(event, ["flags_as_map", "coaching", "is_set"])) {
    tab_names = _.without(tab_names, "coaching");
  }
  if (
    !_.include(
      _.get(AuthedUserSession, ["activeCompanyIds"]),
      _.parseInt(_.get(event, ["companyID"]))
    )
  ) {
    return [];
  }
  return tab_names;
};

module.exports = dd.createClass({
  render() {
    let { event } = this.props;
    if (!event || event.eid < 1) {
      return dd.div();
    }

    return dd.div(
      { className: "EventTabs" },
      TabSet({
        tabs: _.object(
          _.map(determineTabNamesToDisplay(event), function (name) {
            return [
              name,
              _.assign(
                {
                  url: "#/events/" + event.eid + "/" + name,
                },
                tabs[name]
              ),
            ];
          })
        ),
        render_props: this.props,
        selected_tab: this.props.selected_tab,
      }),
      AuthedUserSession.is_privatelabel
        ? dd.p({ className: "text-center text-muted" }, "powered by eSpeakers")
        : null
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/EventTabs.js